import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { Persistor, Store } from "./redux/store";
import { PersistGate } from "redux-persist/lib/integration/react";
import "./index.css";
import App from "./App";
import ICPPageLoader from "./components/loader/ICPPageLoader";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// replace console.* for disable log on production
if (process.env.REACT_APP_ENVIRONMENT === "production") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

// Warn if Google Client ID is missing
if (!clientId) {
  console.warn(
    "REACT_APP_GOOGLE_CLIENT_ID is not set. Google OAuth will not work."
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

// Conditionally render GoogleOAuthProvider only if clientId exists
const AppWithProviders = () => {
  if (clientId) {
    return (
      <GoogleOAuthProvider clientId={clientId}>
        <App />
      </GoogleOAuthProvider>
    );
  }
  return <App />;
};

root.render(
  <HelmetProvider>
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <Provider store={Store}>
        <PersistGate loading={<ICPPageLoader />} persistor={Persistor}>
          <AppWithProviders />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </HelmetProvider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
